<template>
<v-row>
  <v-col cols="12" lg="6">
    <v-textarea v-if="$vuetify.breakpoint.mobile"
                dense
                rows="3"
                label="* Descricao"
                :rules="descricaoRules"
                v-model.trim="value.descricao"/>
    <v-text-field v-else label="* Descricao"
                  dense
                  :rules="descricaoRules"
                  v-model.trim="value.descricao"/>
  </v-col>
  <v-col cols="12" lg="6">
    <v-textarea v-if="$vuetify.breakpoint.mobile"
                dense
                rows="3"
                label="* Nome"
                :rules="nomeRules"
                v-model.trim="value.nome"/>
    <v-text-field v-else label="* Nome"
                  dense
                  :rules="nomeRules"
                  v-model.trim="value.nome"/>
  </v-col>
  <v-col cols="12" lg="8">
    <lookup-dominio label="* Tipo"
                    :hidden-clear="true"
                    v-model="value.tipo"
                    :type="lookups.tipoParametro"
                    :rules="tipoRules"/>
  </v-col>
  <v-col cols="12" lg="4">
    <v-text-field label="Ordem"
                  dense
                  type="number"
                  v-model.trim="value.ordem"/>
  </v-col>
  <v-col cols="12" v-if="ehTipo(TipoParametroEnum.BOOLEAN)">
    <v-switch label="* Valor"
              color="primary"
              inset
              dense
              :true-value="'1'"
              :false-value="'0'"
              v-model="value.valor"/>
  </v-col>
  <v-col cols="12" v-else-if="ehTipo(TipoParametroEnum.LISTA)">
    <v-row dense>
      <v-col cols="12" v-for="(opcao, index) in opcoesLista" :key="index">
        <div class="d-flex align-start">
          <v-text-field dense
                        :label="`* Opcao ${index + 1}`"
                        :rules="valorRules"
                        v-model.trim="opcoesLista[index]"
                        @input="atualizaValorLista"/>
          <v-btn icon
                 color="error"
                 class="ml-2"
                 :disabled="opcoesLista.length <= 2"
                 @click="removeOpcao(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <v-btn small
               color="primary"
               @click="addOpcao">
          <v-icon left>mdi-plus</v-icon>
          Adicionar opcao
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
  <v-col cols="12" v-else-if="ehTipo(TipoParametroEnum.VALOR_MONETARIO)">
    <v-text-field dense
                  label="* Valor"
                  prefix="R$"
                  v-money="moneyConfig"
                  :rules="valorRules"
                  v-model.trim="value.valor"/>
  </v-col>
  <v-col cols="12" v-else-if="ehTipo(TipoParametroEnum.NUMERO)">
    <v-text-field dense
                  type="number"
                  label="* Valor"
                  :rules="valorRules"
                  v-model.trim="value.valor"/>
  </v-col>
  <v-col cols="12" v-else-if="ehTipo(TipoParametroEnum.VALOR_CRIPTOGRAFADO)">
    <v-text-field dense
                  type="password"
                  autocomplete="new-password"
                  label="* Valor"
                  :rules="valorCriptografadoRules"
                  v-model.trim="value.valor"/>
  </v-col>
  <v-col cols="12" v-else>
    <v-textarea v-if="$vuetify.breakpoint.mobile"
                dense
                rows="3"
                label="* Valor"
                :rules="valorRules"
                v-model.trim="value.valor"/>
    <v-text-field v-else label="* Valor"
                  dense
                  :rules="valorRules"
                  v-model.trim="value.valor"/>
  </v-col>
</v-row>
</template>

<script>
import {ItemDeDominio} from "../../../api/itemsDominio";
import {TipoParametroEnum} from "@/enum/Enum";
import LookupDominio from "../common/LookupDominio";

export default {
  name: "ParametroForm",
  components: {LookupDominio},
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      TipoParametroEnum,
      opcoesLista: ['', ''],
      sincronizandoLista: false,
      lookups: {
        tipoParametro: ItemDeDominio.TIPO_PARAMETRO_ENUM,
      },
      descricaoRules: [
        this.$validators.string.required,
        v => this.$validators.string.greaterThanOrEquals(v, 1),
        v => this.$validators.string.lessThanOrEquals(v, 150)
      ],
      nomeRules: [
        this.$validators.string.required,
        v => this.$validators.string.greaterThanOrEquals(v, 1),
        v => this.$validators.string.lessThanOrEquals(v, 150)
      ],
      tipoRules: [
        this.$validators.notNullOrUndefined
      ],
      valorRules: [
        this.$validators.string.required,
        v => this.$validators.string.greaterThanOrEquals(v, 1),
        v => this.$validators.string.lessThanOrEquals(v, 150)
      ],
    }
  },
  computed: {
    valorCriptografadoRules() {
      if (this.value?.id) return [];
      return this.valorRules;
    },
  },
  watch: {
    'value.tipo': {
      immediate: true,
      handler(newValue) {
        this.value.tipo = newValue;
        this.ajustaValorPorTipo();
      }
    },
    'value.valor': {
      immediate: true,
      handler() {
        if (this.ehTipo(TipoParametroEnum.LISTA) && !this.sincronizandoLista) {
          this.sincronizaListaComValor();
        }
      }
    },
  },
  methods: {
    ehTipo(tipo) {
      return (this.value?.tipo || TipoParametroEnum.TEXTO) === tipo;
    },
    ajustaValorPorTipo() {
      if (!this.value.tipo) {
        this.value.tipo = TipoParametroEnum.TEXTO;
      }
      if (this.ehTipo(TipoParametroEnum.BOOLEAN)) {
        this.inicializaValorBoolean();
      }
      if (this.ehTipo(TipoParametroEnum.LISTA)) {
        this.sincronizaListaComValor();
      }
    },
    inicializaValorBoolean() {
      if (!this.value) return;

      const normalizado = String(this.value.valor || '').trim().toUpperCase();
      const valor = normalizado === '1' ? '1' : '0';
      this.$set(this.value, 'valor', valor);
    },
    sincronizaListaComValor() {
      const opcoes = String(this.value.valor || '')
        .split(',')
        .map(opcao => opcao.trim())
        .filter(opcao => opcao !== '');
      while (opcoes.length < 2) {
        opcoes.push('');
      }
      this.opcoesLista = opcoes;
      this.atualizaValorLista();
    },
    atualizaValorLista() {
      this.sincronizandoLista = true;
      this.value.valor = this.opcoesLista
        .map(opcao => String(opcao || '').trim())
        .filter(opcao => opcao !== '')
        .join(',');
      this.$nextTick(() => {
        this.sincronizandoLista = false;
      });
    },
    addOpcao() {
      this.opcoesLista.push('');
      this.atualizaValorLista();
    },
    removeOpcao(index) {
      if (this.opcoesLista.length <= 2) return;
      this.opcoesLista.splice(index, 1);
      this.atualizaValorLista();
    },
    validateParametro() {
      if (this.ehTipo(TipoParametroEnum.LISTA)) {
        this.atualizaValorLista();
      }
      if (this.ehTipo(TipoParametroEnum.BOOLEAN)) {
        this.inicializaValorBoolean();
      }
      return true;
    },
    buildPayload() {
      this.validateParametro();
      return {
        descricao: this.value.descricao,
        nome: this.value.nome,
        valor: this.value.valor,
        tipo: this.value.tipo,
        ordem: this.value.ordem || 0,
      }
    },
  }
}
</script>

<style scoped>

</style>
